const radConfig = {
  allottement_status: false,
  currentUrl: "https://virrd.aikenist.com/",
  previousVisitUrl: "https://medapps.medallcorp.in",
  baseUrl: "https://virrd.aikenist.com/api/quickrad",
  baseUrlRadio: "https://virrd.aikenist.com/api/quickrad/radio",
  radTitle: "AIkenist Technology Pvt. Ltd.",
  viewerURL: "https://virrd.aikenist.com/aikenviewer/viewer/",
  abdmBaseUrl: "https://abdm.aikenist.com",
  viewer3DURL:"https://virrd.aikenist.com/3daikenviewer/viewer?StudyInstanceUIDs=",
  viewerPET:"https://virrd.aikenist.com/3daikenviewer/tmtv?StudyInstanceUIDs=",
  viewerSM:"https://virrd.aikenist.com/3daikenviewer/microscopy?StudyInstanceUIDs=",
  viewerSeg:"https://virrd.aikenist.com/3daikenviewer/segmentation?StudyInstanceUIDs=",
  viewerECG: "https://virrd.aikenist.com/3daikenviewer/ecg?StudyInstanceUIDs=",
  viewerMultiple: "https://virrd.aikenist.com/3daikenviewer/viewer?",
  viewerMultiplePet: "https://virrd.aikenist.com/3daikenviewer/tmtv?",
  medDream:"https://virrd.aikenist.com/?study=",
  thumbnailURL: "https://virrd.aikenist.com/dicom-web/instances/",
  gifURL:
  "https://virrd.aikenist.com/api/quickrad/general/convert-to-gif?series_ins=",
  dicomWeb: "https://virrd.aikenist.com/dicom-web",
  weasisDicomWeb: "http://192.168.1.12:80/dicom-web",
  studyList: "https://virrd.aikenist.com/dicom-web/studies",
  localViewer: "https://virrd.aikenist.com/aikenviewer/local",
  client: "virrd",
  paymentComplete: true,
  version: "v2.0",
  metabaseSiteUrl: "https://metabase.aikenist.com",
  metabaseDashboardId: 2,
  metabaseEmbedSecret: "dc6f5251fdbedfe7884946ce6637cf337639e5eafb07ffebcb62bf197493185b",
  metabaseUseLockedParams: true,
  radiAntPath: "C:\\xampp\\htdocs\\python\\input_scan\\tmp"
};

// ******************************************

localStorage.setItem("client", radConfig.client);

if (
  localStorage.getItem("showTAT") == "" ||
  localStorage.getItem("showTAT") == null
) {
  localStorage.setItem("showTAT", "false");
}
if (
  localStorage.getItem("studyTracker") == "" ||
  localStorage.getItem("studyTracker") == null
) {
  localStorage.setItem("studyTracker", "false");
}

export default radConfig;
